import { createTransform } from 'redux-persist'
import { DashboardState, initialState } from './dashboardSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  DashboardState,
  Omit<DashboardState, 'error' | 'currentRequest'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, currentRequest, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: DashboardState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      currentRequest: initialState.currentRequest,
      status,
    }
  },
  {
    whitelist: ['dashboard'],
  },
)
